import React, { useEffect, useState } from "react";
import { listAutorizacionesRepuestos } from "../api";
import { errMsg, fmtMoney, fmtDateTime } from "../utils";
import { StatusChip, vehLabel } from "./RepuestosComun";

// Filtros por estado; "count" = llave de me.counts (GET /me).
const FILTROS = [
  { key: "", label: "Todas" },
  { key: "AUTORIZADA", label: "Nuevas", count: "nuevas", hot: true },
  { key: "RECIBIDA", label: "Por facturar", count: "por_facturar" },
  { key: "DEVUELTA", label: "Devueltas", count: "devueltas", hot: true },
  { key: "FACTURADA", label: "En revisión", count: "en_revision" },
  { key: "APROBADA", label: "Aprobadas", count: "aprobadas" },
  { key: "ANULADA", label: "Anuladas" },
];

/** Lista de autorizaciones del proveedor con filtro por estado. */
export default function RepuestosAutorizaciones({ filtro, onFiltro, counts, onOpen, onRefreshCounts }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let alive = true;
    setRows(null);
    setError("");
    listAutorizacionesRepuestos(filtro)
      .then((items) => {
        if (alive) setRows(items);
      })
      .catch((e) => {
        if (!alive) return;
        setError(errMsg(e, "No se pudieron cargar las autorizaciones."));
        setRows([]);
      });
    return () => {
      alive = false;
    };
  }, [filtro, reload]);

  function refresh() {
    setReload((n) => n + 1);
    if (onRefreshCounts) onRefreshCounts();
  }

  const actual = FILTROS.find((f) => f.key === filtro) || FILTROS[0];

  return (
    <>
      <div className="section">
        Autorizaciones de repuestos
        {rows && rows.length > 0 && <span className="count">{rows.length}</span>}
      </div>

      <div className="filters">
        {FILTROS.map((f) => {
          const n = f.count && counts ? Number(counts[f.count] || 0) : null;
          return (
            <button
              key={f.key || "todas"}
              type="button"
              className={`filter ${filtro === f.key ? "on" : ""}`}
              onClick={() => onFiltro(f.key)}
            >
              {f.label}
              {n !== null && n > 0 && (
                <span className={`rep-fcount ${f.hot && filtro !== f.key ? "hot" : ""}`}>{n}</span>
              )}
            </button>
          );
        })}
      </div>

      <div className="rep-toolbar">
        <button type="button" className="btn-sm ghost" onClick={refresh} disabled={rows === null}>
          Actualizar
        </button>
      </div>

      {error && <div className="banner err">{error}</div>}

      {rows === null ? (
        <div className="center"><div className="spinner" /></div>
      ) : rows.length === 0 ? (
        !error && (
          <div className="card">
            <div className="empty">
              {filtro
                ? `No tienes autorizaciones en «${actual.label}».`
                : "Todavía no tienes autorizaciones. Cuando un propietario te autorice un repuesto, aparecerá aquí y te llegará un correo."}
            </div>
          </div>
        )
      ) : (
        rows.map((a) => {
          const nueva = a.status === "AUTORIZADA";
          return (
            <div
              key={a.id}
              className={`card res-card rep-card ${nueva ? "rep-new" : ""}`}
              role="button"
              tabIndex={0}
              onClick={() => onOpen(a.id)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onOpen(a.id);
                }
              }}
            >
              <div className="res-head">
                <span className="res-code">
                  {nueva && <span className="rep-new-badge">Nueva</span>}
                  {a.number || `#${a.id}`}
                </span>
                <StatusChip a={a} />
              </div>
              <div className="rep-desc">{a.description || "—"}</div>
              <div className="res-meta">
                <span>Bus: <b>{vehLabel(a.vehicle)}</b></span>
                <span>Fecha: <b>{fmtDateTime(a.created_at)}</b></span>
              </div>
              <div className="res-extra">
                Autoriza: <b>{a.owner?.name || "—"}</b>
              </div>
              {a.status === "DEVUELTA" && a.return_reason && (
                <div className="res-extra" style={{ color: "#be123c" }}>
                  Devuelta: {a.return_reason}
                </div>
              )}
              <div className="rep-card-foot">
                <span className="rep-amount">{fmtMoney(a.amount)}</span>
                <span className="rep-link">Ver detalle →</span>
              </div>
            </div>
          );
        })
      )}
    </>
  );
}
